import { camelCase } from 'lodash-es';

import { VFlex, VStack, type VStatusBadgeProps, VTooltip } from '@/package';
import { VStatusBadge } from '@/package';
import type { Task } from '@/type';
import { mapTaskStateToWorkProgress } from '@/util';

export const TaskDetailHeader = ({ task }: { task: Task }) => {
  const taskState = mapTaskStateToWorkProgress(task);
  return (
    <VFlex justify="between" items="center">
      <VStack className="px-2" gap={0.25}>
        <VTooltip content={task?.taskName} placement="bottom">
          <div className="max-w-[866px] truncate text-headline-s font-semibold">
            {task?.taskName ?? task?.orgPath}
          </div>
        </VTooltip>
        <div className="text-body-lg text-gray-400">
          {[task?.basePath, task?.orgPath].join('/')}
        </div>
      </VStack>

      <div className="h-fit">
        <VStatusBadge
          variant={
            camelCase(taskState.toLowerCase()) as VStatusBadgeProps['variant']
          }
          size="sm"
        >
          {taskState}
        </VStatusBadge>
      </div>
    </VFlex>
  );
};
